export default __webpack_public_path__ + "static/media/IndustrialSite.6d19a4da.svg";